import script from "./ProfileList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileList.vue?vue&type=script&setup=true&lang=js"

import "./ProfileList.vue?vue&type=style&index=0&id=47674970&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47674970"]])

export default __exports__